import _ from 'lodash';
import React from 'react';

import FanStatusFilter from './fan-status-filter';

class FansFilterBar extends React.Component {
	render () {
		return (
			<div className="grid-x align-middle margin-bottom-1">
				<div className="cell auto">
					<FanStatusFilter />
				</div>
			</div>
		);
	}
}

export default FansFilterBar;
